export default [
  {
    path: '/cwx-phrase',
    name: 'CwxPhrase',
    component: () => import('@/pages/cwxPhrase/index.vue'),
    meta: {
      title: '企微话术库',
      keepAlive: true,
      requiresAuth: true,
    },
    children: [
      {
        path: 'cwx-phraseList',
        name: 'CwxPhraseList',
        component: () => import('@/pages/cwxPhrase/list.vue'),
        meta: {
          title: '话术列表',
        },
      },
      // 添加/编辑话术
      {
        path: 'cwx-phraseForm',
        name: 'CwxPhraseForm',
        component: () => import('@/pages/cwxPhrase/PhraseForm.vue'),
        meta: {
          title: '话术保存',
        },
      },
      // 添加/编辑话术分组
      {
        path: 'cwx-phraseGroupForm',
        name: 'CwxPhraseGroupForm',
        component: () => import('@/pages/cwxPhrase/PhraseGroupForm.vue'),
        meta: {
          title: '话术分组',
        },
      },
    ],
  },
]
